module.exports = __webpack_public_path__ + "img/ruban.9ae63770.png";